import { config } from "../index";

const getAppVersion = () => config.features.appVersion;

export { getAppVersion };
